
export const actions = [
    { label: "No Button", value: "No Button" },
    { label: "Apply Now", value: "Apply Now" },
    { label: "Book Now", value: "Book Now" },
    { label: "Buy Tickets", value: "Buy Tickets" },
    { label: "Call Now", value: "Call Now" },
    { label: "Contact Us", value: "Contact Us" },
    { label: "Download", value: "Download" },
    { label: "Get Directions", value: "Get Directions" },
    { label: "Get Offer", value: "Get Offer" },
    { label: "Get Quote", value: "Get Quote" },
    { label: "Get Showtimes", value: "Get Showtimes" },
    { label: "Learn More", value: "Learn More" },
    { label: "Listen Now", value: "Listen Now" },
    { label: "Message Page", value: "Message Page" },
    { label: "Order Now", value: "Order Now" },
    { label: "Play Game", value: "Play Game" },
    { label: "Request Time", value: "Request Time" },
    { label: "Save", value: "Save" },
    { label: "See Menu", value: "See Menu" },
    { label: "Send Updates", value: "Send Updates" },
    { label: "Shop Now", value: "Shop Now" },
    { label: "Sign Up", value: "Sign Up" },
    { label: "Subscribe", value: "Subscribe" },
    { label: "Watch More", value: "Watch More" },
    { label: "WhatsApp Message", value: "WhatsApp Message" },
  ]